// extracted by mini-css-extract-plugin
export default {"updateValue":"UpdateValue_updateValue__64iuo","replaceRow":"UpdateValue_replaceRow__Weli1"};